import { apiAuthClient } from 'shared/api/lib/apiAuthClient';
import type {
  DeleteCompanyRequestType,
  DeleteCompanyResponseType,
} from '../types';

export const deleteCompany = async ({ id }: DeleteCompanyRequestType) => {
  const url = `/company/${id}`;

  const { data } = await apiAuthClient.delete<DeleteCompanyResponseType>(url);

  return data.data;
};
